import { Link } from "react-router-dom";
import { FaInstagram, FaWhatsapp, FaEnvelope } from "react-icons/fa";
import "./footer.css";

export default function Footer() {
  return (
    <footer className="footer">
      <div className="footer-container">
        {/* Logo */}
        <div className="footer-logo">
          <img src="/images/logos/logo2.webp" alt="Logo" />
          <p>Transformamos tu bienestar con entrenamiento y nutrición personalizada.</p>
        </div>

        {/* Enlaces */}
        <div className="footer-links">
          <h4>Enlaces</h4>
          <Link to="/">Home</Link>
          <Link to="/servicios">Servicios</Link>
          <Link to="/sobre-mi">Sobre Mi</Link>
          <Link to="/blog">Blog</Link>
          <Link to="/contacto">Contacto</Link>
        </div>

        {/* Contacto */}
        <div className="footer-contact">
          <h4>Contacto</h4>
          <a href="mailto:cecyvale0207@gmail.com"><FaEnvelope /> cecyvale0207@gmail.com</a>
          <a href="https://wa.me/5492616504890" target="_blank" rel="noopener noreferrer">
            <FaWhatsapp /> +54 9 2616 504890
          </a>
          <a href="https://instagram.com/cecy_vale84" target="_blank" rel="noopener noreferrer">
            <FaInstagram /> cecy_vale84
          </a>
        </div>
      </div>

      <div className="footer-bottom">
        <p>© {new Date().getFullYear()} MCPERSONALTRAINER. Todos los derechos reservados.</p>
      </div>
    </footer>
  );
}
